import { Tooltip } from '@components/Tooltip';
import { useIsOverflowing } from '@lib/hooks/useIsOverflowing';
import { Text } from '@servicetitan/anvil2';
import styles from './TaskText.module.css';
import classNames from 'classnames';
import { getTestIdProps } from '@lib/testUtils';

export const TaskText = ({
  label,
  text,
  tooltip,
  isEyebrow = false,
  isHeadline = false,
  className,
  'data-testid': dataTestId,
}: {
  label?: string;
  text: string;
  tooltip?: string;
  isEyebrow?: boolean;
  className?: string;
  isHeadline?: boolean;
  'data-testid'?: string;
}) => {
  const [ref, isOverflowing] = useIsOverflowing(text);

  const content = (
    <div
      className={classNames(styles.container, className)}
      {...getTestIdProps(dataTestId)}
    >
      {label && (
        <Text variant='eyebrow' size='small' className={styles.labelText}>
          {label}
        </Text>
      )}
      {isEyebrow && (
        <Text
          size='medium'
          variant='eyebrow'
          ref={ref}
          className={classNames(styles.text, styles.eyebrowText, className)}
        >
          {text}
        </Text>
      )}
      {isHeadline && (
        <Text
          el='h4'
          size='small'
          variant='headline'
          ref={ref}
          className={classNames(styles.text, styles.headlineText, className)}
        >
          {text}
        </Text>
      )}
      {!isHeadline && !isEyebrow && (
        <Text
          size='small'
          variant={'body'}
          className={classNames(
            styles.text,
            !label && styles.bodyText,
            className,
          )}
          ref={ref}
        >
          {text}
        </Text>
      )}
    </div>
  );

  return isOverflowing && tooltip ? (
    <Tooltip text={tooltip} triggerClassName={styles.tooltipTrigger}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};
